import axiosClient from "../axios/axiosClient";

export function login(data) {
  return axiosClient.post("/login", data, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

export function getCurrentLoggedInUser() {
  return axiosClient.get("/authenticated-user");
}

export function logoutUser() {
  return axiosClient.get("/logout");
}

export function getPasswordResetCode(data) {
  return axiosClient.post("/reset-code", data);
}

export function resetPasswordWithCode(data) {
  return axiosClient.post("/reset-password-with-code", data);
}

export function updateUserPassword(userId, data) {
  return axiosClient.post(`/update-password/user/${userId}`, data);
}
